export class PasswordChangeRequest {
    Token : string = '';
    NewPassword: string = '';
    ConfirmPassword: string = '';
}

